export default __webpack_public_path__ + "static/N0244-3840ae8e88787a30ac55bc69a5315154.png";